/**
 * A component that accepts a string of text with our special markdown and formats
 * it into HTML for the browser to render. This special markdown is used in discussion
 * posts so users can add basic styling to the text they're submitting.
 *
 * We also escape the text to avoid code injection from nefarious users.
 *
 * The types of markdown and their formatted HTML are as follows:
 * - *string* -> <b>string</b>
 * - _string_ -> <em>string</em>
 * - `string` -> <code>string</code>
 * - ```string``` -> <pre><code>string</pre></code>
 * - http://string.com -> <a href="http://string.com">http://string.com</a>
 */
import * as React from "react";

import {formatContent} from "./format-content.tsx";

type Props = {
    string: string;
};

export default class FormattedMarkdown extends React.Component<Props> {
    render(): React.ReactNode {
        const formattedContent = formatContent(this.props.string, true);
        return <span dangerouslySetInnerHTML={{__html: formattedContent}} />;
    }
}
